import cx from "classnames";

import {
  TokenFavoriteKey,
  tokensFavoritesTabOptionLabels,
  tokensFavoritesTabOptions,
  useTokensFavorites,
} from "context/TokensFavoritesContext/TokensFavoritesContextProvider";
import { useLocalizedMap } from "lib/i18n";

import Button from "components/Button/Button";
import { SwipeTabs } from "components/SwipeTabs/SwipeTabs";
import Tabs from "components/Tabs/Tabs";

export function FavoriteTabs({
  favoritesKey,
  className,
  activeClassName = "",
}: {
  favoritesKey: TokenFavoriteKey;
  className?: string;
  activeClassName?: string;
}) {
  const { tab, setTab } = useTokensFavorites(favoritesKey);

  const localizedTabOptionLabels = useLocalizedMap(tokensFavoritesTabOptionLabels);

  // return (
  //   <div className="flex items-center gap-4 whitespace-nowrap">
  //     {tokensFavoritesTabOptions.map((option) => (
  //       <Button
  //         key={option}
  //         type="button"
  //         variant={"ghost"}
  //         className={cx("!text-body-medium !py-7", className, {
  //           "!bg-gray-neutral": tab === option,
  //           [activeClassName]: activeClassName && tab === option,
  //         })}
  //         onClick={() => setTab(option)}
  //         data-selected={tab === option}
  //       >
  //         {localizedTabOptionLabels[option]}
  //       </Button>
  //     ))}
  //   </div>
  // );

  // return <SwipeTabs
  //   options={tokensFavoritesTabOptions}
  //   optionLabels={localizedTabOptionLabels}
  //   option={tab}
  //   onChange={setTab}
  //   wrapperClassname="w-max"
  //   optionClassname="px-21"
  // />

  return (
    <Tabs
      options={tokensFavoritesTabOptions.map((option) => ({
        label: localizedTabOptionLabels[option],
        value: option,
      }))}
      selectedValue={tab}
      onChange={setTab}
      variant="filled"
      className="w-max"
      regularOptionClassname="!px-21"
    />
  );
}
